<!-- ---------------------------- Profile Popover ------------------------------- -->
@if (isShowProfileDropdown) {
  <div class="profile-dropdown">
    <ul class="profile-menu">
      <!-- ----------------------------------------------------------------------- -->
      <!--                            Business profile                             -->
      <!-- ----------------------------------------------------------------------- -->
      <li class="position-relative w-100 mb-2 p-0">
        <div class="business-profile">
          <div class="business-img">
            <img
              alt=""
              [src]="businessData.logoUrl || 'assets/default-user-image.png'"
            />
          </div>

          <div class="business-info">
            <p class="font-size color-black">
              {{ businessData.name }}
            </p>

            <p class="mt-1 font-size-14 color-gray">
              Business ID: {{ businessData.id }}
            </p>

            <!-- Hiding switch Business Link as it is broken on dev right now -->
            <!-- <p
              *ngIf="
                (userRole || usersData.roles) === RoleNameEnum.ADMIN &&
                isLinkedToMultipleBusinesses
              "
              class="switch-business-link"
              (click)="onSwitchBusiness()"
            >
              Switch Business →
            </p> -->
          </div>
        </div>
      </li>

      <div class="hr"></div>

      <!-- ----------------------------------------------------------------------- -->
      <!--                            User Profile Info                            -->
      <!-- ----------------------------------------------------------------------- -->
      <li class="position-relative w-100 mb-2 p-0">
        <div class="profile-section">
          <img
            class="profile-menu-img"
            alt="User Profile Image"
            [src]="
              (usersData.profileImageUrl || 'assets/default-user-image.png') +
              '?t=' +
              timestamp
            "
          />
          <div class="">
            <p class="profile-section-name mb-2"
              >{{ usersData.firstName + ' ' + usersData.lastName }} ({{
                userRole || usersData.roles
              }})</p
            >
            <p class="profile-section-email mb-0">{{ usersData.username }}</p>
          </div>
        </div>
      </li>
      <div class="hr"></div>

      <!-- ----------------------------------------------------------------------- -->
      <!--                         Settings and other menu                         -->
      <!-- ----------------------------------------------------------------------- -->
      @for (menu of profileMenus; track menu.label; let id = $index) {
        <li
          class="menu-items"
          (click)="onClickProfileMenu(menu.route, menu.label)"
        >
          <span class="icons" [innerHTML]="menu.icon"></span>
          {{ menu.label }}
        </li>
        @if (id === 0 || id === 2) {
          <div class="hr"></div>
        }
      }
    </ul>
  </div>
}
